export const SCENE_QUERY_KEYS = {
  adaptedFictionEditionComments: (adaptedFictionEditionId: string) =>
    ['adaptedFictionEditionComments', adaptedFictionEditionId] as const,

  adaptedFictionEditionReplies: (adaptedFictionEditionId: string, commentId?: string) =>
    commentId
      ? ['adaptedFictionEditionReplies', adaptedFictionEditionId, commentId]
      : (['adaptedFictionEditionReplies', adaptedFictionEditionId] as const),

  sceneCommentDetail: (adaptedFictionEditionId: string, commentId: string) =>
    ['sceneCommentDetail', adaptedFictionEditionId, commentId] as const,

  sceneSubscriptions: (
    type?:
      | 'SceneThread'
      | 'SceneChat'
      | 'SceneEpisode'
      | ('SceneThread' | 'SceneChat' | 'SceneEpisode')[]
  ) => (type ? ['sceneSubscriptions', type] : ['sceneSubscriptions']),
  sceneDetail: (sceneId?: string) => (sceneId ? ['sceneDetail', sceneId] : ['sceneDetail']),
  sceneContents: ['sceneContents'],
  adaptedFictionPreviews: ['adaptedFictionPreviews'],
  castRelationship: (castRelationshipId?: string) =>
    castRelationshipId ? ['castRelationship', castRelationshipId] : ['castRelationship'],
  castRelationships: (perPage?: number) =>
    perPage ? ['castRelationships', perPage] : ['castRelationships'],
  sceneAllParagraphs: (sceneId: string) => ['sceneAllParagraphs', sceneId],
  sceneEpisodeParagraphs: (sceneId: string, episodeId: string) => [
    'sceneEpisodeParagraphs',
    sceneId,
    episodeId
  ],
  sceneOriginalEpisodes: (sceneId: string) => ['sceneOriginalEpisodes', sceneId],
  sceneProducts: ['sceneProducts'],
  adaptedFictionPreviewDetail: (adaptedFictionPreviewId: string, castRelationshipId: string) =>
    ['adaptedFictionPreviewDetail', adaptedFictionPreviewId, castRelationshipId] as const
};

